import { css } from "styled-components";
import { hexToRGB } from "@shared/utils/misc.ts";

export const collapsedMenuPopoverItems = css`
  .ant-menu-submenu-title:hover,
  .ant-menu-item:not(.ant-menu-item-selected):hover,
  :not(.ant-menu-submenu-selected) > .ant-menu-title-content div:hover,
  .ant-menu-title-content div {
    background-color: transparent !important;
  }
  .ant-menu-submenu-popup .ant-menu-vertical .ant-menu-item {
    padding: 0;
    &:first-child,
    &:first-child:hover {
      background: ${(p) =>
        hexToRGB(p.theme.colors.primaryBlue, 0.05)} !important;
    }
    &:not(:first-child) {
      height: 30px !important;
      line-height: 30px !important;
    }
  }
  .ant-menu-submenu .ant-menu-item {
    border-radius: 0;
    display: flex;
    align-items: center;
    .ant-menu-title-content {
      width: 100%;
    }
  }
  .ant-menu-inline-collapsed .ant-menu-submenu-selected .ant-menu-submenu-title,
  .ant-menu-submenu-popup .ant-menu-item-selected {
    background: ${(p) => p.theme.colors.lightBlue}!important;
    border-right: 3px solid ${(p) => p.theme.colors.primaryBlue}!important;
  }
  ${(p) =>
    p.theme.isNewLook &&
    css`
      .ant-menu-inline-collapsed
        .ant-menu-submenu-selected
        .ant-menu-submenu-title,
      .ant-menu-submenu-popup .ant-menu-item-selected {
        border-right: none !important;
      }
    `}
  .ant-menu {
    ul,
    li,
    span,
    div,
    a {
      transition: unset !important;
    }
  }
`;
